import dayjs from "dayjs";
import Axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { ApiService } from "./api.service";
import { DecryptAes } from "@/utils/cryptohelper";
import { AesResponse } from "@/models/responses/aes.response.interface";
import { KeyVaultResponse, Tags, Attributes } from "@/models/responses/keyvault.response.interface";
import { ODataMultipleResponse, ODataBaseResponse } from "@/models/responses/odata.response.interface";
import { SUBSCRIPTION, TOKEN_ID } from "@/store/types";
import { SYSTEM_USER, EMAIL, USER_PORTAL, SESSION_ID } from "@/store/types";
import store from "@/store";
import { userService } from "@/services/user.service";
import { FLOW_SUSCRIPTION } from "@/constants/config";
import { TokenValue } from "@/models/responses/keyvault.response.interface";

interface TokenResponse {
  token_type: string;
  expires_in: number;
  ext_expires_in: number;
  access_token: string;
}

export class LoginServices extends ApiService {
  public constructor(config?: AxiosRequestConfig) {
    super(config);
    // const access_token = "";
    // const access_token_apim = "";
    // this.getToken = this.getToken.bind(this);
    // this.getSecret = this.getSecret.bind(this);
    this.findDescription = this.findDescription.bind(this);
    this.getSuscription = this.getSuscription.bind(this);
    this.getTokenApim = this.getTokenApim.bind(this);
    this.initSettings = this.initSettings.bind(this);
  }

  // public async getToken(): Promise<string> {
  //   await Axios.get("https://login.microsoftonline.com/a658f411-2354-436f-a8c1-520ecaac0e01/oauth2/v2.0/token", {
  //     params: {
  //       client_id: "ca7bb772-3321-4606-8785-409b533bc6f9",
  //       client_secret: "YBV8Q~65ucyjVugDrYjFsiET90cUBEqZAJ4_~cfi",
  //       grant_type: "client_credentials",
  //       scope: "https://vault.azure.net/.default"
  //     },
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded"
  //     }
  //   }).then((response) => {
  //     this.access_token = response.data.access_token;
  //   });

  //   return this.access_token;
  // }

  public async getSuscription(): Promise<void> {
    // const f = FLOW_SUSCRIPTION.split(",");
    const resAes = await Axios.post<AesResponse, AxiosResponse<AesResponse>>(
      // "https://prod-102.westus.logic.azure.com:443/workflows/3911b5030ad7446d8de8d3b3d9ae93ce/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=_YM5AV38FxX-zm6PxrTcO1-YUnPWXABWlzj8xrzuV30"
      // `https://prod-${f[0]}.westus.logic.azure.com:443/workflows/${f[1]}/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=${f[2]}`
      // "https://prod-49.westus.logic.azure.com:443/workflows/a3f74fb88e834e24a28c175d18fff818/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=EYd0Jq7ifOiFL6jrIbjjx6nI8F0luSbpTPIsonaF1dc"
      `${decodeURIComponent(FLOW_SUSCRIPTION)}`
    );

    const resDecrypt = DecryptAes(resAes.data.ValueResponse) as string;
    const json = JSON.parse(resDecrypt);
    const response = json as KeyVaultResponse;

    store.dispatch(SUBSCRIPTION, response);
  }

  public async getTokenApim(): Promise<void> {
    // const f = store.getters.getFlowTokenApim.split(",");
    const f = store.getters.getFlowTokenApim;
    const resAes = await Axios.post<AesResponse, AxiosResponse<AesResponse>>(
      // "https://prod-78.westus.logic.azure.com:443/workflows/859a598c122c4303b87ca99069314f1a/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=7gh1B5obS39SA4aBwpUQqRUBZeGrTTr7Q8jWVqsL858"
      // `https://prod-${f[0]}.westus.logic.azure.com:443/workflows/${f[1]}/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=${f[2]}`
      `${f}`
    );

    const resDecrypt = DecryptAes(resAes.data.ValueResponse) as string;
    const json = JSON.parse(resDecrypt);
    const response = json as TokenResponse;

    const sec = Math.round(response.expires_in * 0.9);
    const now = dayjs();
    const expireDate = now.add(sec, "second");

    const tokenValue: TokenValue = {
      TOKEN: response.access_token,
      EXPIRE_DATE: expireDate
    };

    store.dispatch(TOKEN_ID, tokenValue);
  }

  // public async getTokenApim(): Promise<void> {
  //   await Axios.get("https://login.microsoftonline.com/a658f411-2354-436f-a8c1-520ecaac0e01/oauth2/v2.0/token", {
  //     params: {
  //       grant_type: "client_credentials",
  //       client_id: "b819ed13-a541-453d-954a-26ef99fe52f1",
  //       client_secret: "5Ij8Q~KXeHBDxxzK4hqGvcnba4PFkRHSw5npybi1",
  //       scope: "api://0114e007-bc3e-4af5-9813-76b60733de2b/.default"
  //     },
  //     headers: {
  //       "Content-Type": "application/x-www-form-urlencoded"
  //     }
  //   }).then((response) => {
  //     this.access_token_apim = response.data.access_token;
  //   });

  //   return this.access_token_apim;
  // }

  // public async getSecret(token: string): Promise<string> {
  //   const id = "";
  //   // const tg: Tags = { Origen: "", Tipo: "" };
  //   // const attr: Attributes = { enabled: false, created: 0, updated: 0, recoveryDays: 0, recoveryLevel: "" };
  //   // const result: KeyVaultResponse = { id: "", value: "", contentType: "", tags: tg, attributes: attr };
  //   await Axios.get("https://kv-lsf-dev.vault.azure.net/secrets/OrigenPortalOriginacion/fee4307f9ed6484bad5bde8d3789df75?api-version=7.3", {
  //     headers: {
  //       Authorization: "Bearer " + token
  //     }
  //   }).then((response) => {
  //     this.id = response.data.id;
  //     // result.value = response.data.value;
  //     // result.contentType = response.data.contentType;
  //   });

  //   return this.id;
  // }

  public async findDescription(name: string, suscription: string, token: string): Promise<string> {
    const res = await Axios.get<{ rs_descripcion: string }, AxiosResponse<ODataMultipleResponse<{ rs_descripcion: string }[]>>>(
      `https://lbt-dev-scus-ams-sr-001.azure-api.net/d365api/v1/rs_variabledelsistemas?$filter=rs_name eq '${name}'&$select=rs_descripcion`,
      {
        headers: {
          Authorization: "Bearer " + token,
          "Ocp-Apim-Subscription-Key": "04918c568d3b49f2b589eb883ef05e36"
        }
      }
    );

    if (res.data.value.length <= 0) return "";
    return res.data.value[0].rs_descripcion;
  }

  public async initSettings(): Promise<void> {
    const subscription = store.getters.getSubscription;
    const baseUri = store.getters.getUrlBase;
    if (!subscription || !baseUri) {
      await this.getSuscription();
    }
  }

  public IsAuthenticated(): boolean {
    const email = store.getters.getMail;
    const user = store.getters.getUser;
    if (email && user) {
      return true;
    }
    return false;
  }

  public async InitSession(): Promise<boolean> {
    await this.initSettings();

    const token = localStorage.getItem("tokenPCC");
    const user = localStorage.getItem("userPCC");
    if (token && user) {
      const resp = await userService.validateActiveLogin(token, user);
      if (resp.code == 200) {
        store.dispatch(USER_PORTAL, resp.data.user.id);
        store.dispatch(EMAIL, resp.data.user.name);
        store.dispatch(SYSTEM_USER, resp.data.systemUserId);
        store.dispatch(SESSION_ID, resp.data.sessionId);

        return true;
      } else {
        store.dispatch(USER_PORTAL, "");
        store.dispatch(EMAIL, "");
        store.dispatch(SYSTEM_USER, "");
        store.dispatch(SESSION_ID, "");

        localStorage.removeItem("tokenPCC");
        localStorage.removeItem("userPCC");
        return false;
      }
    } else {
      return false;
    }
  }
}

export const loginService = new LoginServices();
